// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage"
import { getAuth, signInAnonymously, onAuthStateChanged } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || ''
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);

// FIX(TC-WEB-MSG-002): Firebase Storage returned 403 because the default Storage
// Rules (`allow read, write: if request.auth != null`) reject unauthenticated
// uploads.  Main app auth is Keycloak — Firebase had no identity at all.  Sign
// in anonymously on init so message attachments can be uploaded.  Promise is
// exposed so callers can await auth readiness before calling uploadBytes*.
export const firebaseAuth = getAuth(app);

export const firebaseAuthReady = new Promise((resolve) => {
  const unsubscribe = onAuthStateChanged(firebaseAuth, (user) => {
    if (user) {
      unsubscribe();
      console.info("Firebase anonymous auth ready; uid:", user.uid);
      resolve(user);
    }
  });
  signInAnonymously(firebaseAuth).catch((err) => {
    // The most common cause here is Anonymous sign-in being disabled in the
    // Firebase console (Authentication → Sign-in method → Anonymous).  Surface
    // the underlying Firebase error code so the operator can act on it rather
    // than staring at a generic Storage 403 downstream.
    console.error(
      "Firebase anonymous sign-in failed. Storage uploads will fail with 403 " +
      "unless Anonymous is enabled in Firebase Auth, or Storage Rules allow " +
      "unauthenticated writes. Firebase error:",
      err && err.code,
      err && err.message
    );
    unsubscribe();
    resolve(null);
  });
});
